import * as urls from '~/routing/urls';
import {push as pushPath} from 'react-router-redux';

export default (store) => nextDispatch => action => {
  nextDispatch(action);
  if (action.pending || action.error || action.type !== 'USER_DATA') {
    return;
  }

  const {user, routing} = store.getState();
  if (user.isLoggedIn && routing.pathname === urls.LANDING) {
    store.dispatch(pushPath('/'));
  }
};



// WEBPACK FOOTER //
// ./src/middlewares/routing.js